import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
// import projectImage1 from '../../../../assets/images/work/sn-cas/CAS_slider.jpg';
import projectImage2 from '../../../../assets/images/work/sn-cas/CAS_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/sn-cas/CAS_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/sn-cas/CAS_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/sn-cas/CAS_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/sn-cas/CAS_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/sn-cas/CAS_Slider_7.jpg';
import projectImage8 from '../../../../assets/images/work/sn-cas/CAS_Slider_8.jpg';

import Data_SNCAS from './Data_SNCAS';

function Work_SNCAS() {
    return (
        <>
            <DetailedHeader
                heading="Empowering the Next Generation of Change Agents"
                client="Science North"
                service="Installation"
                date="2022-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=GGCqzm8CMw4"
                images={[
                    // {
                    //     image: projectImage1,
                    //     alt: 'Project Image',
                    // },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage7,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage8,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_SNCAS.content}
        </>
    );
}

export default Work_SNCAS;
